module.exports = __webpack_public_path__ + "img/snappicture_01.5facadfd.jpg";